import React, { useState, useEffect } from 'react';
import ServiceCard from '../../../../components/main/cards/ServiceCard/ServiceCard';
import * as servicesApi from '../../../../api/services/servicesApi';
import './OurServices.css';

export default function OurServices() {
  const [services, setServices] = useState();

  const getAllServices = async () => {
    try {
      const allServices = await servicesApi.getServices();
      setServices(allServices);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllServices();
  }, []);

  return (
    <>
      <div className='services-container'>
        <h1 className='services-title'>OUR SERVICES</h1>
        <div className='services-cards-container'>
          {services &&
            services.map(
              (s, i) =>
                s.showOnServices && (
                  <div key={i} className='services-card-container'>
                    <ServiceCard
                      title={s.title}
                      image={s.imageUrl}
                      serviceLink={s.janeUrl}
                      leftDesc={s.description}
                    />
                  </div>
                ),
            )}
        </div>
      </div>
    </>
  );
}
